import React from "react";

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
} from "@material-ui/core";
import firebase from "firebase";
import { useForm } from "react-hook-form";
import { useState } from "react";
import DialogCommon from "../../../../components/dialogs/DialogCommon";
import { AxiosError } from "axios";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";

const useStyles = makeStyles((theme) => ({
  modal: {
    "& .MuiDialog-container": {
      [theme.breakpoints.up("md")]: {
        height: "100%",
      },
    },
    "& .MuiDialog-paper": {
      margin: 4,
    },
  },
}));

export interface ManageAppsProps {
  isLoading: any;
  setOpenDialog: any;
  openDialog: any;
  setIsLoading: any;
  setAlertMessage: any;
  setError: any;
}

const PasswordResetModal: React.FunctionComponent<ManageAppsProps> = ({
  isLoading,
  setOpenDialog,
  openDialog,
  setIsLoading,
  setAlertMessage,
  setError,
}) => {
  const [email, setEmail] = useState("");
  const { register, errors } = useForm();

  const handleCancel = () => {
    setOpenDialog(false);
  };

  const handleResetPassword = async () => {
    // Set 'isLoadingPasswordReset' state to true, indicating the start of the process
    setIsLoading(true);
    try {
      // Attempt to send a password reset email using Firebase authentication
      await firebase.auth().sendPasswordResetEmail(email);
      setIsLoading(false);
      setOpenDialog(false);
      setAlertMessage("Please check your email");
    } catch (error) {
      const err: any = error as AxiosError;
      setError(err.message);
      setIsLoading(false);
      setError(err.message);
    }
  };

  const handleChange = (e: any) => {
    const { value } = e.target;
    setEmail(value);
  };

  const classes = useStyles();

  return (
    <DialogCommon
      open={openDialog}
      setOpen={()=>setOpenDialog(false)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Reset Password</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <TextfieldDefault
              id="email"
              name="email"
              label="Email"
              type="email"
              value={email}
              onChange={handleChange}
              style={{ width: "370px" }}
              inputRef={register({
                required: true,
                minLength: 2,
                maxLength: 30,
              })}
              helperText={errors.password ? "Please enter password" : ""}
              error={errors.password?.type}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleResetPassword}
          color="inherit"
          autoFocus
          style={{ marginRight: "12px" }}
        >
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Send Reset Link"
          )}
        </Button>
      </DialogActions>
    </DialogCommon>
  );
};

export default PasswordResetModal;
